import React from "react";
import Footer from "components/footers/FiveColumnDark";
import Hero from "components/hero/Hero";
import GlobalStyle from "helpers/GlobalStyle";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import useScreenSize from "helpers/useScreenSize";
import WebsiteRenewalAnnouncement from "components/announcement/WebsiteRenewalAnnouncement";

export default () => {
  const { isXs } = useScreenSize();

  return (
    <div style={{ marginTop: "50px" }}>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <WebsiteRenewalAnnouncement />
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
